import module from 'fan/proyecto/module.js'
import template from './template.html'

export class FanProyectoConfiguracionH2hEditarComponent {
  copia
  opciones
  onClose
  procesando
  form

  constructor(FanProyectoConfiguracionH2h) {
    this.idProyecto = undefined
    this.data = undefined
    this.opciones = [{id: 1, identificador: true, descripcion: 'Permitir'}, {id: 2, identificador: false, descripcion: 'No permitir'}]
    this.procesando = false
    this.FanProyectoConfiguracionH2hService = FanProyectoConfiguracionH2h
  }

  $onInit() {
    this.copia = Object.assign({}, this.data)
  }

  actualizar() {
    if (this.procesando) return

    this.procesando = true
    this.FanProyectoConfiguracionH2hService.put(this.idProyecto, this.data)
      .then(() => {
        this.form.$setPristine()
        this.onClose()
      })
      .catch((error) => (this.error = error.error))
      .finally(() => (this.procesando = false))
  }

  cerrar() {
    this.data = Object.assign(this.data, this.copia)
    this.onClose()
  }
}

module.component('fanProyectoConfigH2hEditar', {
  controller: FanProyectoConfiguracionH2hEditarComponent,
  template: template,
  bindings: {
    idProyecto: '<',
    data: '<',
    onClose: '&',
  },
})



// WEBPACK FOOTER //
// ./src/fan/proyecto/components/configuracion/h2h/editar/component.js